module.exports = __webpack_public_path__ + "static/p-2-1c5eb7e6f39300b6832e20698beee4d5.png";